
import { defineComponent, toRefs, reactive, watch } from 'vue';
import { useRouter } from 'vue-router';
import store from '@/store';
import * as timeago from 'timeago.js';

import Navbar from '@/components/Navbar.vue';
import Post from '@/components/Post.vue';
import Subcomment from '@/components/Subcomment.vue';
import SubredditSidebar from '@/components/SubredditSidebar.vue';
import InfoSidebar from '@/components/InfoSidebar.vue';

export default defineComponent({
	components: {
		Navbar,
		SubredditSidebar,
		Post,
		Subcomment,
		InfoSidebar,
	},
	setup() {
		const router = useRouter();
		const route = router.currentRoute;
		const pages = ['posts', 'comments', 'options'];

		const local = reactive({
			menu: 'posts',
			optionsInput: {
				name: store.user.state.currentUser?.name ?? 'New User',
				image:
					store.user.state.currentUser?.image ??
					'https://cdn.discordapp.com/attachments/840294039861723166/855395382720331776/maxresdefault.png',
				about: store.user.state.currentUser?.about ?? '',
				admin: store.user.state.currentUser?.admin ?? false,
			},
		});

		const user = toRefs(store.user.state).currentUser;
		async function init() {
			local.optionsInput = {
				name: store.user.state.currentUser?.name ?? 'New User',
				image:
					store.user.state.currentUser?.image ||
					'https://cdn.discordapp.com/attachments/840294039861723166/855395382720331776/maxresdefault.png',
				about: store.user.state.currentUser?.about || '',
				admin: store.user.state.currentUser?.admin || false,
			};

			local.menu = 'posts';
			if (pages.some((x) => x === route.value.params.page)) local.menu = route.value.params.page.toString();

			if (user.value?.id === route.value.params.id) return;

			store.user.state.posts = [];
			store.user.state.comments = [];
			user.value = null;
			user.value = await store.users.actions.getUser(route.value.params.id.toString());
			if (!store.user.state.currentUser) return router.push({ path: '/404' });
			document.title = `${store.user.state.currentUser.name} | (not) reddit`

			store.user.actions.bindSubmissions((route.value.params.id as string) || '');
		}

		init();

		watch(
			() => [route.value.params.id, route.value.params.page],
			(name) => {
				if (route.value.name === 'User' && name[0]) init();
			}
		);

		const format = (date: Date) => timeago.format(date);

		async function updateProfile() {
			if (!user.value) return;
			let input = local.optionsInput;

			if (input.name.length > 25 || input.name.length < 3) return alert('Your username must be under 25 letters and over 3.');
			if (!/https:\/\//gi.test(input.image)) return alert('Your image must be an https link.');
			if (input.about && input.about.length > 400) return alert('Your about must not be longer than 400 characters.');
			if (input.admin && !store.auth.state.user?.admin) return alert('wtf');

			input.about = input.about.replace(/\n{3}\n*/g, '\n\n');
			input.name = input.name.replace(/\n+/g, '');

			await store.user.actions.updateProfile({
				name: input.name,
				image: input.image,
				about: input.about,
				admin: input.admin,
				id: user.value.id,
			});
		}

		return {
			router,
			route,
			local,
			store,
			user,
			format,
			updateProfile,
		};
	},
});
